import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f5863848"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "checkbox-container green" };
const _hoisted_2 = ["checked", "id"];
const _hoisted_3 = ["for"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isInitCheck: { type: Boolean },
        id: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const checked = ref(props.isInitCheck);
        const onChange = () => {
            checked.value = !checked.value;
            emit('change', checked.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    type: "checkbox",
                    checked: props.isInitCheck,
                    id: `toggle-${props.id}`,
                    onChange: onChange
                }, null, 40, _hoisted_2),
                _createElementVNode("label", {
                    for: `toggle-${props.id}`
                }, null, 8, _hoisted_3)
            ]));
        };
    }
});
